export const getCurrentLocale = ({registry}) => {
    const { languages, defaultLocale, currentLocale } = registry.formContext;
    return currentLocale || defaultLocale || languages && languages.length && languages[0] || undefined
}

export default getCurrentLocale